import classNames from "classnames";
import React from "react";
import styles from "./chatItemBorder.css";

export enum BackgroundType {
  CURRENT_USER_OR_ORG = "current-user",
  AGENT = "agent",
  BOT = "bot",
  LEAD = "lead",
  TYPING_PREVIEW = "typing-preview"
}

interface Props {
  backgroundType: BackgroundType;
  widgetStyle?: boolean;
  shadow?: boolean;
}

export class ChatItemBorder extends React.Component<Props> {
  private static STYLE_MAPPING = new Map([
    [BackgroundType.CURRENT_USER_OR_ORG, styles.own],
    [BackgroundType.AGENT, styles.agent],
    [BackgroundType.BOT, styles.bot],
    [BackgroundType.LEAD, styles.lead],
    [BackgroundType.TYPING_PREVIEW, styles["typing-preview"]]
  ]);

  render() {
    const { widgetStyle, backgroundType, children, shadow } = this.props;
    return (
      <div
        className={classNames(
          styles.container,
          widgetStyle ? styles.widget : styles.dashboard,
          ChatItemBorder.STYLE_MAPPING.get(backgroundType),
          shadow && styles.shadow
        )}
      >
        {children}
      </div>
    );
  }
}
